module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqCAYAAADbCvnoAAAABHNCSVQICAgIfAhkiAAAAVFJREFUWIXt1D9OAlEQgPFv1kKirb21NAsxoafnAnZGCwGzHICewCZ2JLsVJ+ACHIBal8KOxFhaWhALxbFA8E/AWUDE4n3de5lMfsXblUqiyj/K2zbgew5k5UBWDmTlQFYOZOVAVg5k5UBWDmTlQFYOZOVAVg5k5UBWngonwP22IcAIOBOA0zvN7D0SKtS2hOnJmCA6lqF8vq0mWlRoAYU/owj12Jfmx3FOlRutIzQ2TEkEgign/a++BV3catZ7JgRKG8C045zMfR4LQdOqAz1XpQUcrKtQeBAliPPSXTRjfvaRL53xC0dAZy2N0N3dwf8JMxlbonKiJVFChOySnFqck3aawaVA0yoDbaDUU4z2RQmivCRpd68EAignWpDJL6I4d0BpxnlJg/4d0Aw20JooIZB5vxqKEES+9FbZtzYI4PJaD189WsDTvhBc+TJaddcbsNNUjXWlTJcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train/sort(2).png
// module id = O/Gw
// module chunks = 1